export class BaseLineConfiguration {
    setIfDef(obj, configName, configObj) {
        if (configObj[configName] != undefined) {
            obj[configName] = configObj[configName];
        }
        return obj;
    }
}